import React from 'react'
import { Formik, Form, Field, FormikHelpers } from 'formik'
import * as yup from 'yup'
import zxcvbn from 'zxcvbn'
import { WbControlHint } from '@workbench/react/dist'
import { Button, InputField } from 'components'
import { useTranslation } from 'react-i18next'

interface PasswordResetUpdateFormValues {
  password: string
  confirmPassword: string
}

const initialValues: PasswordResetUpdateFormValues = {
  password: '',
  confirmPassword: '',
}

const validationSchema = yup.object({
  password: yup
    .string()
    .min(8, 'pages.login.global.password.minComplexity')
    .required('pages.login.global.password.required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'pages.login.global.password.mustMatch')
    .required('pages.login.global.password.repeatRequired'),
})

const validatePassword = (value: string) => {
  const passwordValidation = zxcvbn(value)
  if (passwordValidation.score < 2) {
    return 'pages.login.global.password.toWeak'
  }
}

interface PasswordResetUpdateFormProps {
  onSubmit: (
    values: PasswordResetUpdateFormValues,
    formikHelpers: FormikHelpers<PasswordResetUpdateFormValues>
  ) => void
}

export const PasswordResetUpdateForm: React.FunctionComponent<PasswordResetUpdateFormProps> = ({
  onSubmit,
}) => {
  const { t } = useTranslation()
  const hint = (
    <>
      <WbControlHint>
        {t('pages.login.global.password.minComplexity')}
      </WbControlHint>
      <WbControlHint>
        {t('pages.login.global.password.noDuplicate')}
      </WbControlHint>
    </>
  )
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <Field
          component={InputField}
          id="password"
          name="password"
          type="password"
          label={t(
            'pages.login.passwordResetPage.passwordResetUpdateForm.newPassword'
          )}
          hint={hint}
          required
          validate={validatePassword}
        />

        <Field
          component={InputField}
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          label={t('pages.login.global.password.confirmPassword')}
          required
        />

        <Button type="submit" aria-label="Submit">
          {t('global.sendup')}
        </Button>
      </Form>
    </Formik>
  )
}
